export const styles = () => ({
  root: { padding: 10 },
  rootLabel: { backgroundColor: '#fff', top: -2 },
  input: { borderRadius: 30 },
  baseSelect: { '&:focus': { borderRadius: 30 } },
  dropdownIcon: { paddingRight: 10 },
  formControl: { position: 'relative' },
  formHelperText: { position: 'absolute', top: '50px' },
});
